import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initAnimations } from './globalAnimations';

gsap.registerPlugin(ScrollTrigger);

// Smooth scroll

export const lenis = new Lenis({
  lerp: 0.075,
  wheelMultiplier: 1.3,
  touchMultiplier: 1.3,
})

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

export const initAnim = () => {
  const menuToggler = document.querySelector('.nav-toggler');
  const headerItems = document.querySelectorAll('.menu-item a');
  const submenuTriggers = document.querySelectorAll('.menu-item-has-children a');


  // Prevent page scrolling on press space 
  window.addEventListener('keydown', (event) => {
    const isEditable = ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable;
  
    if (!isEditable  && event.code === 'Space') {
      event.preventDefault();
    }
  });

  initAnimations()

  // Animation for mobile menu
  function animateMobileMenu() {
    menuToggler.addEventListener('click', function () {
      if (this.classList.contains('menu-open')) {
        headerItems.forEach((el, index) => {
          gsap.fromTo(el, 
            { y: 500 * (index + 1), opacity: 0 }, 
            { y: 0, opacity: 1, duration: 0.9, ease: "cubic-bezier(0.7, 0, 0.3, 1)"}
        );
        });
      }
    });
  }


  // Animation for desktop submenu
  function openSubmenu(el) {
    const submenu = el.nextElementSibling;

    if (!submenu || submenu.classList.contains('open')) return;

    const submenuLinks = submenu.querySelectorAll('a');
    gsap.fromTo(submenuLinks, {
      y: 200,opacity: 0 }, 
      { y: 0, opacity: 1, duration: 0.6, stagger: 0.05}
    );
    el.classList.add('active');
    submenu.classList.add('open');
  }

  function closeSubmenu(el) {
    const submenu = el.nextElementSibling;

    if (!submenu || !submenu.classList.contains('open')) return;

    if (!submenu.matches(':hover') && !el.matches(':hover') && !submenu.matches(':focus-within') && !el.matches(':focus-within')) {
      submenu.classList.remove('open');
      el.classList.remove('active');
    }
  }

  function animateDesktopSubmenu() {
    submenuTriggers.forEach((el) => {
      el.addEventListener('focus', () => openSubmenu(el));
      el.addEventListener('mouseenter', () => openSubmenu(el));
      el.addEventListener('blur', () => closeSubmenu(el));
      el.addEventListener('mouseleave', () => closeSubmenu(el));

      // Keep submenu open when focused

      const submenu = el.nextElementSibling;
      if (submenu) {
        submenu.addEventListener('mouseleave', () => closeSubmenu(el));
        submenu.addEventListener('focusin', () => {
          if (!submenu.classList.contains('open')) {
            submenu.classList.add('open');
          }
        });
        submenu.addEventListener('focusout', () => closeSubmenu(el));
      }
    });
  }

  // Animation for preloader

  function animatePreloader() {
    window.onload = () => {
      const preloader = document.querySelector('.loaded-wrapper');
      if (!preloader) return;

      const loader = preloader.querySelector('.loader');
      const svg = preloader.querySelector('svg');
      const pathDots = svg ? Array.from(svg.querySelectorAll('path')).slice(0, 3) : [];

      loader.classList.remove('hide')

      gsap.set(pathDots, {
        y: -200, opacity: 0,
      })

      gsap.to(
        pathDots, { y: 0,opacity: 1,duration: 2, stagger: 0.05, ease: "bounce.out" }
      );

      [{ selector: "#maskRect1", from: { x: -126, opacity: 0 }, to: { x: 0, opacity: 1, duration: 1.5 } },
        { selector: "#maskRect2", from: { x: 126, opacity: 0 }, to: { x: 0, opacity: 1, duration: 1.5 } }]
        .forEach(({ selector, from, to }) => {
            gsap.fromTo(
                selector,
                { ...from, ease: "power2.inOut" },
                to
            );
        });

      document.body.classList.add('disable-scroll');

      setTimeout(() => {
        preloader.classList.add('hide');
        document.body.classList.remove('disable-scroll');
      }, 2000);
    };
  }

  return {
    init() {
      animateMobileMenu();
      animateDesktopSubmenu();
      animatePreloader(); // front page preloader on page load (runs only if .loaded-wrapper exists)
    },
  }
};
